module.exports = __webpack_public_path__ + "static/media/17UN-Women7.0e4377a1.jpg";